/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PeriodQueryContract} from '../../../api/contracts/period/period-query.contract';
import {PeriodQueryModel} from './period-query.model';
import {PaginationCriteriaMapper} from '../../pagination-criteria.model.ts/pagination-criteria.mapper';
import {PeriodSearchCriteriaMapper} from '../period-search-criteria/period-search-criteria.mapper';

export class PeriodQueryMapper {

    static fromPeriodQueryContract(input: PeriodQueryContract): PeriodQueryModel {
        let model: PeriodQueryModel;

        if (input != null) {
            model = {
                paginationCriteria: PaginationCriteriaMapper.fromPaginationCriteriaContract(input.paginationCriteria),
                searchCriteria: PeriodSearchCriteriaMapper.fromPeriodSearchCriteriaContract(input.searchCriteria)
            };
        }
        return model;
    }

    static toPeriodQueryContract(input: PeriodQueryModel): PeriodQueryContract {
        let model: PeriodQueryContract;

        if (input != null) {
            model = {
                paginationCriteria: PaginationCriteriaMapper.toPaginationCriteriaContract(input.paginationCriteria),
                searchCriteria: PeriodSearchCriteriaMapper.toPeriodSearchCriteriaContract(input.searchCriteria)
            };
        }
        return model;
    }
}
